<template>
  <mdb-container>
    <mdb-card>
      <mdb-card-header class="pt-4 indigo">
        <mdb-card-title class="text-white">
          <strong>{{ $t("new_bug_report") }}</strong>
        </mdb-card-title>
      </mdb-card-header>
      <mdb-card-body>
        <mdb-row class="mt-3">
          <mdb-col md="12">
            <mdb-input
              v-model="form.title"
              icon="tag"
              :label="$t('bug_title')"
            />
          </mdb-col>
        </mdb-row>

        <mdb-row class="mt-2">
          <mdb-col md="12">
            <label class="text-muted small ml-3">{{ $t("bug_component") }}</label>
            <div class="ml-3 mt-1 d-flex flex-wrap">
              <div
                v-for="comp in components"
                :key="comp"
                class="mr-4 d-flex align-items-center"
                style="gap: 6px"
              >
                <input
                  type="checkbox"
                  class="plain-checkbox"
                  :id="'comp-' + comp"
                  :value="comp"
                  v-model="form.selectedComponents"
                />
                <label :for="'comp-' + comp" class="mb-0" style="cursor: pointer">{{ comp }}</label>
              </div>
            </div>
          </mdb-col>
        </mdb-row>

        <mdb-row class="mt-2">
          <mdb-col md="12">
            <mdb-input
              v-model="form.description"
              type="textarea"
              :rows="5"
              icon="align-left"
              :label="$t('bug_description')"
            />
          </mdb-col>
        </mdb-row>

        <mdb-row class="mt-2">
          <mdb-col md="12">
            <label class="text-muted small ml-3">{{ $t("bug_image") }}</label>
            <div class="ml-3 mt-1">
              <input
                type="file"
                accept="image/*"
                @change="onFileChange"
                ref="fileInput"
              />
            </div>
          </mdb-col>
        </mdb-row>

        <mdb-row class="mt-4">
          <mdb-col md="12">
            <mdb-btn
              @click="submit"
              color="indigo"
              class="white-text"
              icon="bug"
              :disabled="submitting"
            >
              {{ $t("bug_submit") }}
            </mdb-btn>
          </mdb-col>
        </mdb-row>
      </mdb-card-body>
    </mdb-card>
  </mdb-container>
</template>

<script>
import {
  mdbContainer,
  mdbRow,
  mdbCol,
  mdbInput,
  mdbBtn,
  mdbCard,
  mdbCardBody,
  mdbCardHeader,
  mdbCardTitle,
} from "mdbvue";

export default {
  name: "BugReport",
  components: {
    mdbContainer,
    mdbRow,
    mdbCol,
    mdbInput,
    mdbBtn,
    mdbCard,
    mdbCardBody,
    mdbCardHeader,
    mdbCardTitle,
  },
  data() {
    return {
      path: "/1.0/front/bugreport",
      components: ["frontti", "android", "ios", "muu"],
      form: {
        title: "",
        description: "",
        selectedComponents: [],
      },
      imageFile: null,
      submitting: false,
    };
  },
  methods: {
    onFileChange(event) {
      this.imageFile = event.target.files[0] || null;
    },
    submit() {
      if (!this.form.title.trim()) {
        this.$notify.warn({
          message: this.$t("bug_title_required"),
          position: "top right",
          timeOut: this.$store.state.notifytimeoutshort,
        });
        return;
      }

      this.submitting = true;
      const formData = new FormData();
      formData.append("title", this.form.title.trim());
      formData.append("description", this.form.description.trim());
      formData.append("labels", this.form.selectedComponents.join(","));
      if (this.imageFile) {
        formData.append("image", this.imageFile, this.imageFile.name);
      }

      this.$http
        .post(this.path, formData, {
          headers: { "Content-Type": undefined },
        })
        .then((response) => {
          if (response.status === 200) {
            this.$notify.success({
              message: this.$t("bug_submit_success") + " " + response.data.key,
              position: "top right",
              timeOut: this.$store.state.notifytimeoutmedium,
            });
            this.resetForm();
          } else {
            this.$notify.error({
              message: this.$t("bug_submit_error"),
              position: "top right",
              timeOut: this.$store.state.notifytimeoutshort,
            });
          }
        })
        .catch((error) => {
          this.$notify.error({
            message: this.$t("bug_submit_error"),
            position: "top right",
            timeOut: this.$store.state.notifytimeoutshort,
          });
          console.log(error);
        })
        .finally(() => {
          this.submitting = false;
        });
    },
    resetForm() {
      this.form.title = "";
      this.form.description = "";
      this.form.selectedComponents = [];
      this.imageFile = null;
      if (this.$refs.fileInput) {
        this.$refs.fileInput.value = "";
      }
    },
  },
};
</script>

<style scoped>
/* MDB's global CSS hides all native [type="checkbox"] elements
   (opacity:0, pointer-events:none, position:absolute) to render its own
   custom checkbox via label ::before/::after. Since these checkboxes don't
   use MDB's markup, override those rules so they're visible and clickable. */
input.plain-checkbox[type="checkbox"] {
  position: static !important;
  opacity: 1 !important;
  pointer-events: auto !important;
  width: 16px;
  height: 16px;
  margin: 0;
}
</style>
